var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"app-iframe",attrs:{"id":_vm.iframeId,"src":_vm.formatedAppUrl,"data-qa":_vm.iframeId,"title":_vm.iframeId}})
}
var staticRenderFns = []

export { render, staticRenderFns }